import axiosInstance from './request';
export default {
  //get请求
  get(url, param, isIntercept = true) {
    const params = {
      ...param
    };
    return new Promise((resolve, reject) => {
      axiosInstance({
        method: 'get',
        url: url,
        headers: { 'Auth-User-Token': sessionStorage.getItem('token') || '' },
        params: params,
        isIntercept: isIntercept
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  //----------------------------------------------post请求
  post(url, param, isIntercept = true) {
    const params = {
      ...param
    };
    return new Promise((resolve, reject) => {
      axiosInstance({
        method: 'post',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'Auth-User-Token': sessionStorage.getItem('token') || ''
        },
        data: params,
        url: url,
        isIntercept: isIntercept
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  //formdata -----------------------------------post请求
  formPost(url, params, isIntercept = true) {
    return new Promise((resolve, reject) => {
      //表单提交判断是null转为"" 防止回显变成"null"
      for (const key in params) {
        params[key] = params[key] === null ? '' : params[key];
      }
      axiosInstance({
        method: 'post',
        url: url,
        data: params,
        transformRequest: [
          function (data) {
            let ret = '';
            for (const it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            return ret;
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Auth-User-Token': sessionStorage.getItem('token') || ''
        },
        isIntercept: isIntercept
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  //文件上传----------------------------请求
  formDataPost(url, params) {
    return new Promise((resolve, reject) => {
      axiosInstance({
        method: 'post',
        url: url,
        data: params,
        headers: {
          'Content-Type': 'multipart/form-data;charset=utf-8',
          'Auth-User-Token': sessionStorage.getItem('token') || ''
        }
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  //文件下载
  downloadFile(url, param, fileName) {
    let fileUrl = url + '?';
    const keys = Object.keys(param);
    const keyList = [];
    for (const key of keys) {
      if (typeof param[key] === 'object') {
        keyList.push(`${key}=${encodeURIComponent(JSON.stringify(param[key]))}`);
      } else {
        keyList.push(`${key}=${encodeURIComponent(param[key])}`);
      }
    }
    fileUrl = fileUrl + keyList.join('&');
    return new Promise((resolve, reject) => {
      axiosInstance({
        method: 'get',
        url: fileUrl,
        headers: { 'Auth-User-Token': sessionStorage.getItem('token') || '' },
        params: {},
        responseType: 'blob'
      })
        .then((res) => {
          let file = null;
          if (fileName.indexOf('.xls') > -1) {
            file = new File([res.data], fileName, {
              type: 'application/vnd.ms-excel;charset=utf-8'
            });
          } else if (fileName.indexOf('.pdf') > -1) {
            file = new File([res.data], fileName, {
              type: 'application/pdf;charset=utf-8'
            });
          } else if (fileName.indexOf('.doc') > -1) {
            file = new File([res.data], fileName, {
              type: 'application/msword;charset=utf-8'
            });
          } else if (fileName.indexOf('.zip') > -1) {
            file = new File([res.data], fileName, {
              type: 'application/zip;charset=utf-8'
            });
          } else {
            file = res.data;
          }
          //ie10+
          if ('msSaveOrOpenBlob' in navigator) {
            navigator.msSaveOrOpenBlob(file, fileName);
            resolve(res);
            return;
          }
          const fileUrl = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = fileUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(fileUrl);
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  download(url, data) {
    return new Promise((resolve, reject) => {
      axiosInstance({
        method: 'post',
        url: url,
        headers: {
          'Auth-User-Token': sessionStorage.getItem('token') || '',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        },
        responseType: 'blob',
        timeout: 60000, // 增加超时时间到60秒
        data
      })
        .then((res) => {
          // 检查响应是否有效
          if (res && res.data) {
            resolve(res);
          } else {
            reject(new Error('响应数据为空'));
          }
        })
        .catch((e) => {
          // 提供更详细的错误信息
          if (e.code === 'ECONNABORTED') {
            reject(new Error('请求超时，请重试'));
          } else if (e.message && e.message.includes('ERR_CONTENT_LENGTH_MISMATCH')) {
            reject(new Error('文件下载不完整，请重试'));
          } else {
            reject(e);
          }
        });
    });
  }
};
